import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { FaArrowRight } from "react-icons/fa6";

// Assets
import CalendarPng from '../assets/calendar.png';

// Styles
import styles from './styles.module.css';

// Types
import { KeyDate } from '../../types';

interface GradedDateProps {
  keyDate: KeyDate;
}

const GradedDate: React.FC<GradedDateProps> = ({ keyDate }) => {
  const { t } = useTranslation();

  if (!keyDate) return null;

  const reamingDays = dayjs(keyDate.date).diff(dayjs(), 'day');

  const renderProgress = () => {
    const progress = keyDate.progress;
    let progressStyle = 'px-2 py-1 rounded-full text-sm';
    if (0 <= progress && progress < 20) {
      progressStyle += ` ${styles.redProgress}`;
    } else if (20 <= progress && progress < 40) {
      progressStyle += ` ${styles.orangeProgress}`;
    } else if (40 <= progress && progress < 60) {
      progressStyle += ` ${styles.amberProgress}`;
    } else if (60 <= progress && progress < 80) {
      progressStyle += ` ${styles.yellowProgress}`;
    } else if (80 <= progress && progress < 100) {
      progressStyle += ` ${styles.greenProgress}`;
    }

    return (
      <div className='flex flex-row items-center gap-2'>
        {keyDate.old_progress && (
          <>
            <p className="text-black">
              {keyDate.old_progress}%
            </p>


            <FaArrowRight className='text-black' />
          </>
        )}

        <p className={progressStyle}>
          {progress}%
        </p>

      </div>
    )
  }

  return (
    <div className={`${styles.keyDate}`}>
      <div className={`${styles.calendarContainer}`}>
        <img src={CalendarPng} alt="calendar" className={`${styles.calendar}`} />
      </div>

      <div className={`${styles.keyDateTextContainer}`}>
        <div className='flex flex-1 flex-row justify-between items-center'>
          <div className='flex flex-col gap-2'>
            <p className='text-md text-gray-500'>
              {t("roadMap.graded_date")}
            </p>

            <p className='text-lg text-black'>
              {keyDate.name}
            </p>
          </div>

          <p className='text-md text-gray-500'>
            {t('progress.streak_count', { count: reamingDays })}
          </p>
        </div>

        <div className={styles.keyDateProgressContainer}>
          <p className='text-md text-gray-500'>
            {t('roadMap.current_progress')}
          </p>

          {renderProgress()}
        </div>
      </div>
    </div>
  )
}

export default GradedDate;
